import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { HeartPulse, Feather, LayoutGrid } from "lucide-react";
import { HealthQuoteForm } from "./HealthQuoteForm";
import { LifeQuoteForm } from "./LifeQuoteForm";
import { QuoteForm } from "./QuoteForm";

const TABS = [
  { k: "health", l: "Health", I: HeartPulse },
  { k: "life", l: "Life", I: Feather },
  { k: "other", l: "Other", I: LayoutGrid },
];

export const QuoteTabs = () => {
  const [tab, setTab] = useState("health");
  useEffect(() => {
    const on = (e) => { if (e.detail) setTab(e.detail); };
    window.addEventListener("quote-tab", on);
    return () => window.removeEventListener("quote-tab", on);
  }, []);

  return (
    <div>
      <div role="tablist" className="mb-5 inline-flex w-full sm:w-auto gap-1 rounded-full bg-white/[0.06] border border-white/15 p-1.5" data-testid="quote-tabs">
        {TABS.map(({ k, l, I }) => (
          <button key={k} role="tab" aria-selected={tab === k} onClick={() => setTab(k)} data-testid={`quote-tab-${k}`}
            className={`relative flex-1 sm:flex-none inline-flex items-center justify-center gap-2 rounded-full px-4 sm:px-6 py-2.5 text-sm font-semibold transition-colors ${tab === k ? "text-[#071510]" : "text-[#F4F1EA]/80 hover:text-white"}`}>
            {tab === k && <motion.span layoutId="quotetab" className="absolute inset-0 rounded-full bg-[#E5A855]" transition={{ type: "spring", stiffness: 320, damping: 30 }} />}
            <I className="relative w-4 h-4" /><span className="relative">{l}</span>
          </button>
        ))}
      </div>
      <motion.div key={tab} initial={{ opacity: 0.3, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}>
        {tab === "health" && <HealthQuoteForm />}
        {tab === "life" && <LifeQuoteForm />}
        {tab === "other" && <QuoteForm />}
      </motion.div>
    </div>
  );
};
